import dayjs from 'dayjs';

export function getTrialDaysRemaining(trialEndTimestamp) {
  if (!trialEndTimestamp) {
    return null;
  }

  const trialEnd = dayjs.unix(Number(trialEndTimestamp));
  if (!trialEnd.isValid()) {
    return null;
  }

  const now = dayjs();
  if (!trialEnd.isAfter(now)) {
    return 0;
  }

  return Math.max(0, trialEnd.diff(now, 'day'));
}

export function formatTrialRemainingText(trialEndTimestamp) {
  const daysRemaining = getTrialDaysRemaining(trialEndTimestamp);

  if (daysRemaining === null) {
    return 'Trial active';
  }

  if (daysRemaining === 0) {
    return 'Trial expires today';
  }

  return `Trial expires in ${daysRemaining} day${daysRemaining === 1 ? '' : 's'}`;
}